module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_career_text-4d7ad83a3841a58ab88e407d3c9c2014.svg";